const $ = jQuery;

export default class ScrollTarget {
	static init() {
        document.addEventListener('bless', () => {
            $(document).on('click', '.js-scroll-down', function(e) {
                e.preventDefault();
                if (
                    location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
                    &&
                    location.hostname == this.hostname
                ) {
                    // Figure out element to scroll to
                    let target = $(this.hash);
                    target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                    // Does a scroll target exist?
                    if (target.length) {
                    // Only prevent default if animation is actually gonna happen
                        e.preventDefault();
                        $('html, body').animate({
                            scrollTop: target.offset().top
                        }, 1000, function() {
                            // Callback after animation
                            // Must change focus!
                            let $target = $(target);
                            $target.focus();

                            if ($target.is(":focus")) {
                                return false;
                            } else {
                                $target.attr('tabindex','-1');
                                $target.focus();
                            };
                        });
                    }
                }
            });
		});
    }
}

